import { fetchAPI } from './api';
import { v4 as uuidv4 } from 'uuid';
import { getCurrentUser } from '@aws-amplify/auth';

function getOrCreateDeviceId(): string {
  const storageKey = 'valolens-device-id';
  let deviceId = localStorage.getItem(storageKey);

  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem(storageKey, deviceId);
  }

  return deviceId;
}

export async function postUsageData(usageType: string): Promise<void> {
  try {
    const deviceId = getOrCreateDeviceId();
    const body: any = {
      device_id: deviceId,
      usage_type: usageType
    };

    // Try to get the current user
    try {
      const user = await getCurrentUser();
      if (user) {
        body.user_id = user.username;
      }
    } catch (error) {
      // User is not logged in, continue without user_id
      console.log('No user logged in');
    }

    await fetchAPI('/usage', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  } catch (error) {
    console.error('Error posting usage data:', error);
    throw error;
  }
}

export async function postMatchUsageData(matchId: string, mapIndex: string, roundNum: string): Promise<void> {
  try {
    const body: any = {
      match_id: matchId,
      map_index: mapIndex,
      roundnum: roundNum
    };

    // Try to get the current user
    try {
      const user = await getCurrentUser();
      if (user) {
        body.user_id = user.username;
      }
    } catch (error) {
      // User is not logged in, continue without user_id
      // console.log('No user logged in');
    }

    await fetchAPI('/usage-matches', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  } catch (error) {
    console.error('Error posting match usage data:', error);
    throw error;
  }
}

